<template lang="pug">
.search-bar-block
  form.search-input-wrapper(@submit.prevent="handleSearch")
    input.search-input(
      v-model="searchTerm"
      type="search"
      :placeholder="block.placeholderText || 'Search'"
      @keyup.enter="handleSearch"
    )
    button.search-icon(type="button" @click="handleSearch" aria-label="Search")
      img(src="@/assets/icons/searchIcon.svg" alt="Search")
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { SearchBarBlock } from '../types';

export default defineComponent({
  name: 'SearchBarBlock',
  props: {
    block: {
      type: Object as () => SearchBarBlock,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();
    const searchTerm = ref('');

    const handleSearch = () => {
      const query = searchTerm.value.trim();
      if (!query) return;

      // Navigate to search page with query parameters
      router.push({
        path: '/web/search',
        query: {
          q: query,
          type: props.block.searchType,
          hint: props.block.placeholderText,
        },
      });
    };

    return {
      searchTerm,
      handleSearch,
    };
  },
});
</script>

<style lang="scss" scoped>
.search-bar-block {
  padding: 0 24px;
  
  // Mobile: more space above (80px), less space below (24px)
  margin-top: 80px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    padding: 0 40px;
    margin-top: 0;
    margin-bottom: 56px;
  }

  @media (min-width: 1024px) {
    padding: 0 64px;
    margin-bottom: 64px;
  }
}

.search-input-wrapper {
  position: relative;
  width: 100%;
  max-width: 600px;
}

.search-input {
  width: 100%;
  height: 56px;
  padding: 0 56px 0 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 16px;
  background: #ffffff;
  color: #1a1a1a;
  transition: all 0.2s;

  &:hover {
    border-color: #0d9488;
  }

  &:focus {
    outline: none;
    border-color: #0d9488;
    box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-50%) scale(1.05);
    box-shadow: 0 4px 12px rgba(13, 148, 136, 0.3);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }
}
</style>
